module.exports = __webpack_public_path__ + "img/pattern_bottom.01f9861c.png";